import { useState, useRef, useEffect } from "react"
import Tooltip from "@mui/material/Tooltip"
import { Col, Offcanvas, Row, Tab, Nav, Dropdown, Modal, Form, InputGroup } from "react-bootstrap"
import imgs from "../../../Utils/assets/img/faces/5.jpg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select"
// Solid icons
import {
  faBriefcase,
  faCalendar,
  faCalendarPlus,
  faEnvelope,
  faLocationDot,
  faMessage,
  faPencil,
  faPhone,
  faRepeat,
  faSortDown,
  faTrash,
  faUser,
  faUserPen,
  faUserPlus,
  faXmark,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { FaFacebook, FaWhatsapp, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa"
import { useGetRequest } from "../../../Utils/hooks/QueryHandler"
import { PutRequest, GetRequest } from "../../../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import "../activity.css"
import { Line } from "react-chartjs-2"
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Legend } from "chart.js"

// Import sub-components
import { Followups } from "./Followups"
import { Notes } from "./Notes"
import { Meetings } from "./Meetings"
import { Documents } from "./Documents"
import { Quotation } from "./Quotation"
import { EmailModal } from "./EmailModal"
import { WhatsappModal } from "../../../pages/WhatsappModal"
import { customStyles, formatDate, getValueOrDash, maskContactNumber } from "../../../Utils/helpers/commonhelper";
import { checkTwilioIntegration } from "../../../Utils/helpers/commonhelper";
import { baseURL } from "../../../Utils/constants/constant";
import { ContactActivity } from "../../../pages/ContactActivity";
import GlobalCallModal from "../../ivr/GlobalCallModal";
import TwilioIntegrationForm from "../../ivr/TwilioIntegrationForm";
import DyanmicCallLog from "../../ivr/DynamicCallLog";
import { useOutsideClickHandler } from "../../../Utils/hooks/useOutsideClickHandler";
import { RightLeadDetailsPanel } from "./RightLeadDetailsPanel";

ChartJS.register(Legend, CategoryScale, LinearScale, PointElement, LineElement)

export const LeadsDetails = ({
  show,
  setRefetchLeadsData,
  onClose,
  onEdit,
  onDelete,
  leadId,
  pipelineStageData,
  canEdit_canDownload
}) => {

  // Pipeline state management
  const [selectedStep, setSelectedStep] = useState(null)
  // const [currentStep, setCurrentStep] = useState("Progress")
  const [isAnimatingOut, setIsAnimatingOut] = useState(false)
  const [clickedStage, setClickedStage] = useState(null)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [confirmAction, setConfirmAction] = useState(null)
  const [reason, setReason] = useState("")
  const pipelineData = pipelineStageData;

  // state for storing the selected pipeline for the won deals modal dropdown
  const [selectedPipelineId, setSelectedPipelineId] = useState("")
  const [pipelineStage, setPipelineStage] = useState([])
  const [selectedStageId, setSelectedStageId] = useState("")

  // modal dropdown state 
  // const [amount, setAmount] = useState("")
  const [documentTitle, setDocumentTitle] = useState("")
  // // Active tab state for lazy loading
  // const [activeTab, setActiveTab] = useState("followups")

  // Dropdown state for three dots menu
  // const [showActionsDropdown, setShowActionsDropdown] = useState(false)
  const [showStatusDropdown, setShowStatusDropdown] = useState(false)
  // const actionsDropdownRef = useRef(null)
  const statusDropdownRef = useRef(null)

  // previous stage tracking state
  const [previouslyCurrentStages, setPreviouslyCurrentStages] = useState(new Set());
  // Email modal state
  const [showEmailModal, setShowEmailModal] = useState(false)

  // WhatsApp modal state
  const [showWhatsappModal, setShowWhatsappModal] = useState(false)

  // Other state
  const [expanded, setExpanded] = useState(false)

  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [callLogOpen, setCallLogOpen] = useState(false);

  // Session and navigation
  const [customer, setCustomer] = useLocalStorageState("customer")
  const navigate = useNavigate()
  const customerId = customer?.customer_details?.customer_id
  const token = customer?.token?.authorization
  const rf = customer?.token?.authentication
  const loginId = customer?.customer_details?.id
  const headers = {
    Authentication: rf,
    Authorization: token,
  }

  const extras = {
    customer,
    setCustomer,
    rf,
    navigate,
  }

  // permission setup for leads
  const permission = customer.customer_details?.permission
  // permission for lead
  const leadPermission = permission?.filter(c => c.module_name === "leads")
  const user_type = Number(customer.customer_details?.user_type)
  const leadGrant = {
    isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.delete)) : true,
  }
  const followupGrant = {
    isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "followup")?.delete)) : true,
  }
  const leadMeetingGrant = {
    isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "meeting")?.delete)) : true,
  }
  const leadDocGrant = {
    isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "document")?.delete)) : true,
  }
  const leadNoteGrant = {
    isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "notes")?.delete)) : true,
  }


  // // Handles tab change and sets active tab for lazy loading
  // const handleTabChange = (tabKey) => {
  //   setActiveTab(tabKey)
  // }

  /**
   * Handles opening email modal
   */
  const handleOpenEmailModal = () => {
    setShowEmailModal(true)
  }

  /**
   * Handles closing email modal
   */
  const handleCloseEmailModal = () => {
    setShowEmailModal(false)
  }
  /**
   * Check WhatsApp integration before opening modal
   */
  const checkWhatsappIntegration = async () => {
    setShowWhatsappModal(true)

  }

  /**
   * Handles opening WhatsApp modal with integration check
   */
  const handleOpenWhatsappModal = () => {
    checkWhatsappIntegration()
  }

  /**
   * Toggles actions dropdown menu
   */
  // const toggleActionsDropdown = () => setShowActionsDropdown((prev) => !prev)

  /**
   * Toggles status dropdown menu
   */
  const toggleStatusDropdown = () => {
    if (!canEdit_canDownload) {
      toast.warning("You are not authorized for this action!")
      return
    }
    setShowStatusDropdown((prev) => !prev)
  }

  /**
   * oses actions dropdown
   */
  // const closeActionsDropdown = () => setShowActionsDropdown(false)

  /**
   * Closes status dropdown
   */
  const closeStatusDropdown = () => setShowStatusDropdown(false)

  /**
   * Handles pipeline stage change API call
   */


  const [currencyOpt, setCurrencyOpt] = useState([])
  const [selectedCurrencyId, setSelectedCurrencyId] = useState(null);

  const handleMakeCurrentStage = async (stageId) => {
    if (!canEdit_canDownload) {
      toast.warning("You are not authorized for this action!")
      return
    }
    if (!leadData || !stageId || stageId === currentActiveStageId) return

    const payload = {
      stage_id: stageId,
      lead_status: "",
      reason: "",
      lead_id: leadData.id,
      customer_id: customerId,
      pipeline_id: leadData.pipeline_id,
      user_login_id: customer.customer_details?.id
    }

    try {
      const response = await PutRequest("lead/changePipelineStageAndStatus/", payload, { headers }, extras)
      if (true) {
        toast.success("Pipeline stage updated successfully")

        // Add the previous current stage to the set of previously current stages
        setPreviouslyCurrentStages(prev => {
          const newSet = new Set(prev);
          if (currentActiveStageId) {
            newSet.add(currentActiveStageId);
          }
          return newSet;
        });

        setClickedStage(null)
        closeWithAnimation()
        refetchLeadDetails()
      } else {
        toast.error(response?.message || "Failed to update pipeline stage")
      }
    } catch (error) {
      toast.error("An error occurred while updating pipeline stage")
    }
  }
  /**
   * Handles lead status change with confirmation dialogs
   */
  const handleStatusChange = async (status) => {
    if (!leadData) return

    if (status === "won") {
      setConfirmAction({ type: "status", status, needsReason: false })
      setShowConfirmDialog(true)
    } else if (status === "unqualified" || status === "lost") {
      setConfirmAction({ type: "status", status, needsReason: true })
      setShowConfirmDialog(true)
    }
  }

  /**
   * Executes the confirmed status change
   */
  const executeStatusChange = async () => {
    if (!confirmAction || !leadData) return

    const payload = {
      stage_id: "",
      currency_id: selectedCurrencyId,
      lead_status: confirmAction.status,
      user_login_id: loginId,
      reason: confirmAction.needsReason ? reason : "",
      lead_id: leadData.id,
      customer_id: customerId,
      pipeline_id: leadData.pipeline_id,
      deal_pipeline_id: selectedPipelineId,
      pipeline_stage_id: selectedStageId || null,
      deal_name: documentTitle || null
    }
    try {
      const response = await PutRequest("lead/changePipelineStageAndStatus/", payload, { headers }, extras)
      if (response?.status === "success") {
        toast.success(`Lead status updated to ${confirmAction.status}`)
        if (confirmAction?.status === "won") {
          navigate("/deals", {
            state: {
              id: response?.data,
              pipelineId: selectedPipelineId
            }
          })
        }
        closeStatusDropdown()
        setDocumentTitle('')
        setSelectedCurrencyId('')
        setSelectedPipelineId(null)
        setSelectedStageId(null)
        setShowConfirmDialog(false)
        setConfirmAction(null)
        setRefetchLeadsData(true)
        setReason("")
        onClose()
      } else {
        toast.error(response?.message || "Failed to update lead status")
      }
    } catch (error) {
      toast.error("An error occurred while updating lead status")
    }
  }

  /**
   * Closes confirmation dialog
   */
  const closeConfirmDialog = () => {
    setSelectedCurrencyId('')
    setSelectedPipelineId(null)
    setShowConfirmDialog(false)
    setConfirmAction(null)
    setReason("")
  }

  /**
   * Handles pipeline step animation close
   */
  const closeWithAnimation = () => {
    setIsAnimatingOut(true)
    setTimeout(() => {
      setSelectedStep(null)
      setIsAnimatingOut(false)
    }, 300)
  }

  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customerId, headers, extras)
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }

    } catch (error) {
      console.error(error)
    } finally {
      setIsCheckingTwilio(false);
    }
  }

  /**
   * Toggles detail expansion
   */
  const toggleDetailExpand = () => setExpanded((prev) => !prev)

  const getMobileNumberByType = (phoneStr, type = "Mobile") => {
    try {
      if (phoneStr && typeof phoneStr === "string") {
        const phoneArray = JSON.parse(phoneStr)
        if (Array.isArray(phoneArray) && phoneArray.length > 0) {
          // Find phone by type or return first one
          const phoneObj = phoneArray.find((phone) => phone.phone_type === type)
          if (phoneObj) {
            return `${phoneObj.country_code} ${maskContactNumber(phoneObj.phone)}`
          }
        }
      }
      return "-"
    } catch (error) {
      return "-"
    }
  }

  // Fetch lead details using the API
  const {
    data: leadDetailsResponse,
    isLoading: isLeadLoading,
    refetch: refetchLeadDetails,
  } = useGetRequest(
    `lead/leadsDetails/${customerId}/${leadId}`,
    "fetchLeadDetails",
    headers,
    extras
  );

  // useeffect for fetching pipeline stage based on the pipeline id and hydrating it in the won deals dropdown modal
  const pipelineStageUrl = selectedPipelineId
    ? `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}`
    : null;

  // Fetch pipeline stages for selected pipeline
  const {
    data: stageData,
  } = useGetRequest(
    pipelineStageUrl,
    ["stageDataInDetails", selectedPipelineId, customerId], // 👈 added dependencies
    headers,
    extras,
  );

  useEffect(() => {
    if (stageData?.data?.length > 0) {
      const stageDataToStore = stageData.data.map((s) => ({
        value: s.id,
        label: s.stage_name,
      }));
      setSelectedStageId("")
      setPipelineStage(stageDataToStore);
    } else {
      setPipelineStage([]);
    }
  }, [stageData]);

  // Add this useEffect to refetch when leadId changes
  useEffect(() => {
    if (leadId && customerId && show) {
      refetchLeadDetails();
    }
  }, [leadId, customerId, show, refetchLeadDetails]);

  // Extract lead data from API response
  const leadData = leadDetailsResponse?.data || null;
  // Find current active stage based on pipeline_stage_id
  const currentActiveStage = pipelineData?.find(stage => stage.id === leadData?.pipeline_stage_id?.toString());
  const currentActiveStageId = currentActiveStage?.id;

  // /**
  //  * Handles edit action
  //  */
  // const handleEdit = () => {
  //   if (onEdit && leadData) {
  //     onEdit(leadData.id)
  //   }
  //   closeActionsDropdown()
  //   onClose()
  // }

  // /**
  //  * Handles delete action
  //  */
  // const handleDelete = () => {
  //   if (onDelete && leadData) {
  //     onDelete(leadData.id)
  //   }
  //   closeActionsDropdown()
  //   onClose()
  // }

  /**
   * Handles follow up action
  //  */
  // const handleFollowUp = () => {
  //   if (onFollowUp && leadData) {
  //     onFollowUp(leadData.id)
  //   }
  //   closeActionsDropdown()
  //   onClose()
  // }

  /**
   * Handles modal close
   */
  // const handleClose = () => {
  //   onClose()
  // }

  /**
   * Handles task overlay click
  //  */
  // const handleClick = (event) => {
  //   setShows(!shows)
  //   setTargets(event.target)
  // }

  // useeeffect for fetching currency value dropdown.
  useEffect(() => {
    (async () => {
      const res = await GetRequest(`deals/fetchActiveCurrency/${customerId}`, { headers }, extras)
      if (res.status === "fail" || res.success === false) {
        return
      }

      const currencyOptions = res.data && res.data?.map(item => {
        try {
          // Parse the currency string to object
          const currencyObj = JSON.parse(item.currency);

          // Create React Select option
          return {
            value: item.id, // Using the item's id as value
            label: `${currencyObj.label} (${currencyObj.value})` // Format: "Chilean Peso (CLP)"
          };
        } catch (error) {
          console.error('Error parsing currency:', error);
          return null;
        }
      }).filter(option => option !== null); // Remove any null entries from failed parsing

      setCurrencyOpt(currencyOptions)
    })()
  }, [])


  const {
    data: pipelines,
    isLoading: isPipelineLoading,
    refetch: refetchPipeline,
  } = useGetRequest(`lead/fetchPipelines/${customerId}/deals/${customer.customer_details?.id}/${customer.customer_details?.user_type}`, ["fetchLeadsPipeline"], headers, extras, {})

  // // Close dropdowns on outside click
  // useOutsideClickHandler({
  //   objRef: actionsDropdownRef,
  //   isDropdown: showActionsDropdown,
  //   setDropdown: setShowActionsDropdown
  // })
  useOutsideClickHandler({
    objRef: statusDropdownRef,
    isDropdown: showStatusDropdown,
    setDropdown: setShowStatusDropdown
  })


  if (!show) return null
  // Show loading state
  if (isLeadLoading) {
    return (
      <div className="d-flex w-100">
        <Offcanvas
          className="w-100"
          placement="end"
          backdrop="static"
          show={show}
          onHide={onClose}
          style={{ padding: "0px" }}
        >
          <Offcanvas.Body>
            <div
              className="h-100 pt-4 d-flex justify-content-center align-items-center"
              style={{ borderRadius: "15px", background: "#f9f9f9" }}
            >
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading lead details...</p>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    )
  }

  // Chart data - keep existing chart
  const data = {
    labels: Array.from({ length: 30 }, (_, i) => `Day ${i + 1}`),
    datasets: [
      {
        label: "Monthly Sales",
        data: Array.from({ length: 30 }, () => Math.floor(Math.random() * 100)),
        fill: true,
        borderColor: "#007bff",
        pointBackgroundColor: "#007bff",
        tension: 0.3,
      },
    ],
  }

  const pipelineOptions = pipelines?.data.length > 0
    ? pipelines.data.map((pipe) => ({
      value: pipe.id, // Use id as value to match selectedPipelineId
      label: pipe.pipeline_name // Use name as label for display
    }))
    : [];

  // useEffect(() => {
  //   (async () => {
  //     const res = await GetRequest(`lead/fetchPipelines/${customerId}/deals`, { headers }, extras)
  //     if (res.status === "fail" || res.status === false) {
  //       return
  //     }
  //     setPipelines(res.data)
  //   })()
  // })

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          color: "#343a40",
          font: { size: 11 },
        },
        grid: {
          color: "#e9ecef",
        },
      },
      y: {
        ticks: {
          color: "#343a40",
          font: { size: 11 },
        },
        grid: {
          color: "#e9ecef",
        },
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        labels: {
          color: "#343a40",
          font: { size: 14, weight: "bold" },
        },
        position: "top",
      },
      tooltip: {
        backgroundColor: "#f8f9fa",
        titleColor: "#007bff",
        bodyColor: "#343a40",
        borderColor: "#dee2e6",
        borderWidth: 1,
      },
    },
  }

  return (
    <div className="d-flex w-100">
      <Offcanvas
        className="w-100"
        placement="end"
        backdrop="static"
        show={show}
        onHide={onClose}
        style={{ padding: "0px" }}
      >
        <Offcanvas.Body className="p-0">
          <div className="h-100 pt-4" style={{ borderRadius: "15px", background: "#f9f9f9" }}>
            <Row className="ms-0 w-100 h-100 pe-2 ps-2">
              <Col
                md={7}
                style={{
                  height: "100%",
                  overflow: "auto",
                  borderRadius: "5px",
                  borderRight: "1px solid #e0e4f8",
                  borderTop: "none",
                }}
                className="pt-0 detailsDivs p-0"
              >
                <div
                  className="me-0 pe-2"
                  style={{
                    background: "transparent",
                    paddingTop: "0px",
                    borderRadius: "0px",
                    marginBottom: "10px",
                  }}
                >
                  {/* Header Section with Lead Info */}
                  <div className="d-flex gap-3 align-items-center ps-3 mb-0 me-1" style={styles.stickyHeader}>
                    <div>
                      <div
                        className="rounded-circle overflow-hidden border border-3 d-flex justify-content-center align-items-center"
                        style={{
                          width: "70px",
                          height: "70px",
                          backgroundColor: "#fff",
                          borderColor: "#7a3a5e",
                        }}
                      >
                        <img
                          src={
                            leadData?.contact_image ? `${baseURL}${leadData.contact_image}` : imgs
                          }
                          alt=""
                          className="w-100 h-100"
                          style={{ borderRadius: "50%" }}
                        />
                      </div>
                    </div>
                    <div
                      style={{ color: "#576f91", fontSize: "13px", fontWeight: 500, width: "-webkit-fill-available" }}
                      className="d-flex justify-content-between pe-3"
                    >
                      <div>
                        <h4 className="mb-1" style={{ fontSize: "20px", fontWeight: "500", color: "#3c3c3c" }}>
                          {getValueOrDash(leadData?.contact_name)}
                          <span style={{ color: "#3f97fd" }}>
                            ({getValueOrDash(`#${leadData?.lead_no}`)})
                          </span>
                          <span style={{ color: "#FFC107", fontSize: 13, marginLeft: 7 }}>
                            {[...Array(5)].map((_, index) => {
                              const rating = leadData?.rating || 0;
                              if (rating >= index + 1) {
                                return <FaStar key={index} />;
                              } else if (rating >= index + 0.5) {
                                return <FaStarHalfAlt key={index} />;
                              } else {
                                return <FaRegStar key={index} />;
                              }
                            })}
                          </span>
                        </h4>
                        <p className="mb-0">
                          {getValueOrDash(leadData?.designation)} | {getValueOrDash(leadData?.department)}
                        </p>
                      </div>
                      <div className="d-flex flex-column position-relative">
                        <div className="d-flex gap-1" style={{ marginTop: "-12px" }}>
                          <Tooltip title="Send WhatsApp" placement="top">
                            <button
                              type="button"
                              className="btn btn-whatsapp p-2"
                              style={styles.listWhatsButtonsStyles}
                              onClick={handleOpenWhatsappModal}
                            >
                              <FaWhatsapp style={{ fontSize: "16px" }} />
                            </button>
                          </Tooltip>
                          <div style={styles.emptyDivs}></div>
                          <Tooltip title="Send Mail" placement="top">
                            <button
                              type="button"
                              className="btn btn-primary btnss"
                              style={styles.listWhatsButtonsStyles}
                              onClick={handleOpenEmailModal}
                            >
                              <FontAwesomeIcon icon={faEnvelope} style={styles.iconStyles} />
                            </button>
                          </Tooltip>
                          <Tooltip title="Call" placement="top">
                            <button type="button" className="btn btn-primary btnss" style={styles.listWhatsButtonsStyles} onClick={() => checkTwilio()}>
                              <FontAwesomeIcon icon={faPhone} style={styles.iconStyles} />
                            </button>
                          </Tooltip>
                          <Tooltip title="Send SMS" placement="top">
                            <button type="button" className="btn btn-primary btnss" style={styles.listWhatsButtonsStyles}>
                              <FontAwesomeIcon icon={faMessage} style={styles.iconStyles} />
                            </button>
                          </Tooltip>
                        </div>
                        <div style={{ position: "absolute", top: '1.2rem', right: '0rem', fontSize: '2.5rem', color: '#c4c1c1', fontWeight: 400 }}>
                          LEAD
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="my-3 bg-white me-1" style={{ border: '1px solid rgb(224, 228, 248)', borderRadius: 4, padding: 13 }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 style={{ fontWeight: 300, fontSize: 19 }} className="mb-0"><p className="mb-1 fs-19" style={styles.labels}>Current Pipeline</p> {leadData?.pipeline_name} </h5>
                      <div ref={statusDropdownRef} className="mb-0 position-relative">
                        <button
                          className="btn-default btn d-flex gap-2"
                          style={{ fontSize: 12, borderRadius: 3 }}
                          onClick={toggleStatusDropdown}
                        >
                          {leadData?.lead_status && leadData.lead_status !== "inprogress"
                            ? getValueOrDash(leadData.lead_status)
                            : "Select Lead Status"}{" "}
                          <FontAwesomeIcon icon={faSortDown} />
                        </button>
                        {showStatusDropdown && (
                          <div
                            className="defaultDropdown dropdown-menu"
                            style={{
                              width: "10rem",
                              padding: "7px 0px",
                              display: "block",
                              position: "fixed",
                              top: statusDropdownRef.current?.getBoundingClientRect().bottom + window.scrollY || 0,
                              left: statusDropdownRef.current?.getBoundingClientRect().right - 159 + window.scrollX || 0,
                              zIndex: 9999,
                              backgroundColor: "#fff",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                              boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                            }}
                          >
                            <Dropdown.Item
                              onClick={() => {
                                if (!leadGrant.isEdit) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                handleStatusChange("won")
                              }}
                              className="fs-13 d-flex gap-2 align-items-center"
                            >
                              <i class="fa-solid fa-circle-check" style={{ color: "#00b894" }}></i> Won
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                if (!leadGrant.isEdit) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                handleStatusChange("unqualified")
                              }}
                              className="fs-13 d-flex gap-2 align-items-center"
                            >
                              <i class="fa-solid fa-circle-xmark" style={{ color: "#d63031" }}></i> Unqualified
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                if (!leadGrant.isEdit) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                handleStatusChange("lost")
                              }}
                              className="fs-13 d-flex gap-2 align-items-center"
                            >
                              <i class="fa-solid fa-circle-exclamation" style={{ color: "#fdcb6e" }}></i> Lost
                            </Dropdown.Item>
                          </div>
                        )}
                      </div>

                    </div><hr />
                    {/* <div className="arrow-steps">
                      {pipelineData.map((stage, index) => {
                        const isActive = stage.id === currentActiveStageId;
                        const isClicked = clickedStage === stage.id;
                        const isPrevious = index < pipelineData.findIndex(s => s.id === currentActiveStageId);

                        // let backgroundColor = "transparent"; // Default no color for future stages
                        let backgroundColor = "#c9c9c9"
                        let textColor = ""; // Default text color

                        if (isActive) {
                          backgroundColor = "#7a3a5e"; // Purple for active
                          textColor = "#fff";
                        } else if (isClicked) {
                          backgroundColor = "#7a3a5e"; // Purple for clicked
                          textColor = "#fff";
                        } else if (isPrevious) {
                          backgroundColor = "#28a745"; // Green for previous stages
                          textColor = "#fff";
                        }

                        return (
                          <div
                            key={stage.id}
                            className={`step ${isActive ? "current" : ""}`}
                            onClick={() => {
                              setSelectedStep(stage.stage_name);
                              setClickedStage(stage.id);
                            }}
                            style={{
                              backgroundColor,
                              color: textColor,
                              cursor: "pointer",
                            }}
                          >
                            {stage.stage_name}
                          </div>
                        );
                      })}
                    </div> */}

                    <div className="arrow-steps">
                      {pipelineData?.map((stage, index) => {

                        const isActive = stage.id === currentActiveStageId;
                        const isClicked = clickedStage === stage.id;
                        const wasPreviouslyCurrent = previouslyCurrentStages.has(stage.id);

                        let backgroundColor = ""; // Default gray for inactive stages
                        let textColor = "#000"; // Default text color

                        if (isActive) {
                          backgroundColor = "#7a3a5e"; // Purple for active
                          textColor = "#fff";
                        } else if (isClicked) {
                          backgroundColor = "#7a3a5e"; // Purple for clicked
                          textColor = "#fff";
                        } else if (wasPreviouslyCurrent) {
                          backgroundColor = "#28a745"; // Green for previously current stages
                          textColor = "#fff";
                        }

                        return (
                          <div
                            key={stage.id}
                            className={`step ${isActive ? "current" : ""}`}
                            onClick={() => {
                              setSelectedStep(stage.stage_name);
                              setClickedStage(stage.id);
                            }}
                            style={{
                              backgroundColor,
                              color: textColor,
                              cursor: "pointer",
                            }}
                          >
                            {stage.stage_name}
                          </div>
                        );
                      })}
                    </div>
                    {selectedStep && (
                      <div
                        className={`d-flex align-items-start bg-white animated-fade-in ${isAnimatingOut ? "fade-out" : "fade-in"}`}
                        style={{ marginTop: 10, padding: "14px 6px" }}
                      >
                        <div className="d-flex gap-3 ps-2" style={{ width: "83%" }}>
                          <div style={{ minWidth: '120px' }}>
                            <p className="mb-0 text-nowrap" style={styles.labels}>
                              Stage name
                            </p>
                            <p className="mb-0" style={styles.values}>
                              {selectedStep}
                            </p>
                          </div>
                          <div style={{ minWidth: '120px' }}>
                            <p className="mb-0 text-nowrap" style={styles.labels}>
                              Updated On
                            </p>
                            <p className="mb-0" style={styles.values}>
                              {formatDate(pipelineData.find((stage) => stage.stage_name === selectedStep)
                                ?.update_at || "-")}
                            </p>
                          </div>
                          <div>
                            <p className="mb-0" style={styles.labels}>
                              Description
                            </p>
                            <p className="mb-0" style={styles.values}>
                              {pipelineData.find((stage) => stage.stage_name === selectedStep)
                                ?.stage_description || "-"}
                            </p>
                          </div>
                        </div>
                        {clickedStage !== currentActiveStageId && (
                          <button
                            className="btn btn-default me-0"
                            style={{ fontSize: "13px", textWrap: "nowrap", color: "#fff" }}
                            onClick={() => {
                              if (!leadGrant?.isEdit && !canEdit_canDownload) {
                                toast.warning("You are not authorized for this action!")
                                return
                              }
                              const selectedStageData = pipelineData.find(
                                (stage) => stage.stage_name === selectedStep,
                              )
                              if (selectedStageData) {
                                handleMakeCurrentStage(selectedStageData.id)
                              }
                            }}
                          >
                            Make as Current
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  <div style={{ marginTop: 10 }} className="d-flex gap-2">
                    {/* Left Column - Personal Details */}
                    <div
                      style={{
                        height: "100%",
                        width: "50%",
                        border: "1px solid #e0e4f8",
                        background: "#fff",
                        borderLeft: "1px solid #e0e4f8",
                        height: "fit-content",
                        borderBottom: "1px solid #e0e4f8",
                      }}
                      className="ps-1 mb-3"
                    >
                      {/* Personal Details Section */}
                      <div
                        className="pt-0 ps-0 pb-0"
                        style={{ background: "transparent", marginTop: "1rem", marginLeft: "0.2rem" }}
                      >
                        <h4 style={styles.sectionTitle} className="d-flex justify-content-between align-items-center">
                          Personal Details
                        </h4>
                        <Row className="w-100 ms-0 mb-2">
                          <Col md={6} className="mb-3 d-flex align-items-center" onClick={() => checkTwilio()} style={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={faPhone} style={styles.iconsStyles} className="fs-16" />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Phone
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(getMobileNumberByType(leadData?.user_phone, "Mobile"))}
                              </p>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faPhone} style={styles.iconsStyles} className="fs-16" />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Personal Phone
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(getMobileNumberByType(leadData?.user_phone, "private"))}
                              </p>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faEnvelope} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Email
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.email)}
                              </p>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faLocationDot} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Address
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {/* {(() => {
                                  const addressParts = [
                                    leadData?.address?.trim(),
                                    leadData?.state_name?.trim(),
                                    leadData?.city_name?.trim()
                                  ].filter(part => part && part !== "");

                                  return addressParts.length > 0 ? addressParts.join(", ") : "-";
                                })()} */}
                                {getValueOrDash(leadData?.contact_address)}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <hr />

                      {/* Company Details Section */}
                      <div
                        className="pt-0 ps-0 pb-0"
                        style={{ background: "transparent", marginTop: "0rem", marginLeft: "0.2rem" }}
                      >
                        <h4
                          style={styles.sectionTitle}
                          className="d-flex justify-content-between align-items-center mb-3"
                        >
                          Company Details
                        </h4>
                        <h4
                          style={{
                            ...styles.sectionTitle,
                            color: '#0099ff'
                          }}

                          className="d-flex justify-content-between align-items-center mb-1"
                        >
                          {getValueOrDash(leadData?.company_name)}
                        </h4>
                        <p className="mb-3 fs-13 ms-3" style={{ fontWeight: 400, color: "#999999" }}>
                          <i className="bi bi-geo-alt"></i>
                          {(() => {
                            const addressParts = [
                              leadData?.state_name?.trim(),
                              leadData?.city_name?.trim()
                            ].filter(part => part && part !== "");

                            return addressParts.length > 0 ? addressParts.join(", ") : "-";
                          })()}
                        </p>
                        <Row className="w-100 ms-0 mb-2">
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faBriefcase} style={styles.iconsStyles} className="fs-16" />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Type
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.business_type)}
                              </p>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faUser} style={styles.iconsStyles} className="fs-16" />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Owner
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.company_owner_name)}
                              </p>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faEnvelope} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Email
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.company_email)}
                              </p>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faPhone} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Phone
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getMobileNumberByType(leadData?.company_phone, "Mobile")}
                              </p>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faLocationDot} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Company Address
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {(() => {
                                  const addressParts = [
                                    leadData?.address?.trim(),
                                    leadData?.state_name?.trim(),
                                    leadData?.city_name?.trim()
                                  ].filter(part => part && part !== "");

                                  return addressParts.length > 0 ? addressParts.join(", ") : "-";
                                })()}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <hr />

                      {/* Internal Details Section */}
                      <div
                        className="pt-0 ps-0 pb-0"
                        style={{ background: "transparent", marginTop: "2rem", marginLeft: "0.2rem" }}
                      >
                        <h4 style={styles.sectionTitle} className="d-flex justify-content-between align-items-center">
                          Internal
                        </h4>
                        <Row className="w-100 ms-0 mb-2">
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faUserPlus} style={styles.iconsStyles} className="fs-16" />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Created By
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.lead_added_name)}
                              </p>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faRepeat} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Lead Source
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.source_title)}
                              </p>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faCalendarPlus} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Created Date
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {formatDate(leadData?.created_at)}
                              </p>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faCalendar} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Updated Date
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {formatDate(leadData?.updated_at)}
                              </p>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3 d-flex align-items-center">
                            <FontAwesomeIcon icon={faUserPen} className="fs-16" style={styles.iconsStyles} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Updated By
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {getValueOrDash(leadData?.lead_updated_name)}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <hr />

                      {/* Social Details Section */}
                      <div
                        className="pt-0 ps-0 pb-0"
                        style={{ background: "transparent", marginTop: "2rem", marginLeft: "0.2rem" }}
                      >
                        <h4 style={styles.sectionTitle} className="d-flex justify-content-between align-items-center">
                          Social Details
                        </h4>
                        <Row className="w-100 ms-0 mb-2">
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FaFacebook size={22} className="me-3" style={{ color: "#2656a8" }} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Facebook
                              </p>
                              <a
                                href={leadData?.facebook || "#"}
                                className="mb-0"
                                style={{ fontSize: "0.8333rem", fontWeight: 400 }}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {getValueOrDash(leadData?.facebook)}
                              </a>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FaInstagram size={22} className="me-3" style={{ color: "#2656a8" }} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Instagram
                              </p>
                              <a
                                href={leadData?.instagram || "#"}
                                className="mb-0"
                                style={{ fontSize: "0.8333rem", fontWeight: 400 }}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {getValueOrDash(leadData?.instagram)}
                              </a>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FaTwitter size={22} className="me-3" style={{ color: "#2656a8" }} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Twitter
                              </p>
                              <a
                                href={leadData?.twitter || "#"}
                                className="mb-0"
                                style={{ fontSize: "0.8333rem", fontWeight: 400 }}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {getValueOrDash(leadData?.twitter)}
                              </a>
                            </div>
                          </Col>
                          <Col md={12} className="mb-3 d-flex align-items-center">
                            <FaLinkedinIn size={22} className="me-3" style={{ color: "#2656a8" }} />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Linkedin
                              </p>
                              <a
                                href={leadData?.linkedin || "#"}
                                className="mb-0"
                                style={{ fontSize: "0.8333rem", fontWeight: 400 }}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {getValueOrDash(leadData?.linkedin)}
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>

                    {/* Right Column - Pipeline, Chart, History */}
                    <div style={{ height: "100%", width: "50%", position: "relative" }} className="pt-0 p-0 pe-1">
                      {/* Product Details */}
                      <div
                        style={{
                          overflow: "auto",
                          background: "#fff",
                          paddingTop: "12px",
                          borderRadius: "5px",
                          border: "1px solid #e0e4f8",
                          marginBottom: "10px",
                        }}
                      >
                        <div className="d-flex justify-content-between gap-2 p-2 ps-3 pe-3 pt-0">
                          <div>
                            <p className="mb-2 fs-17" style={{ fontWeight: 300 }}>
                              Associated Deal
                            </p>
                            <p className="mb-0 fs-16" style={{ fontWeight: 400, color: "#0099ff" }}>
                              {/* {getValueOrDash(leadData?.service_name)} */}
                            </p>
                            <p
                              className={`mb-0 fs-13 clamp-text ${expanded ? "expanded" : ""}`}
                              style={{ fontWeight: 300 }}
                            >
                              {getValueOrDash(leadData?.requirement)}
                            </p>
                            {leadData?.requirement && leadData.requirement.trim().split(/\s+/).length > 14 && (
                              <span
                                onClick={toggleDetailExpand}
                                style={{ color: "blue", cursor: "pointer", fontSize: "11px" }}
                              >
                                {expanded ? "Less" : "More"}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="row w-100 ms-0 ps-1 mb-3 mt-2">
                          <div className="mb-2 fs-14 col-md-4">
                            <span
                              style={{
                                fontSize: "12px",
                                color: "rgb(176, 186, 201)",
                                fontWeight: 400,
                              }}
                            >
                              Currency
                            </span>
                            <p className="mb-0 fs-13">Indian Rupees</p>
                          </div>
                          <div className="mb-2 fs-14 col-md-4">
                            <span
                              style={{
                                fontSize: "12px",
                                color: "rgb(176, 186, 201)",
                                fontWeight: 400,
                              }}
                            >
                              Budget
                            </span>
                            <p className="mb-0 fs-13">{getValueOrDash(leadData?.budget)}</p>
                          </div>
                          <div className="mb-2 fs-14 col-md-4">
                            <span
                              style={{
                                fontSize: "12px",
                                color: "rgb(176, 186, 201)",
                                fontWeight: 400,
                              }}
                            >
                              Closure Date
                            </span>
                            <p className="mb-0 fs-13">{formatDate(getValueOrDash(leadData?.expected_closure_date))}</p>
                          </div>
                        </div>
                      </div>
                      {/* Chart Section - Keep existing */}
                      <div
                        className="mt-3 p-3"
                        style={{ background: "#fff", border: "1px solid rgb(224, 228, 248)", borderRadius: 5 }}
                      >
                        <div style={{ width: "auto", height: "313px" }}>
                          <Line data={data} options={options} />
                        </div>
                      </div>

                      {/* History Section - Keep existing */}
                      <div
                        className="mt-3"
                        style={{
                          background: "#fff",
                          border: "1px solid rgb(224, 228, 248)",
                          borderRadius: 5,
                          height: "38.5rem"
                        }}
                      >
                        <h3
                          style={styles.sectionTitle}
                          className="d-flex mt-3 justify-content-between align-items-center"
                        >
                          History
                        </h3>
                        <hr className="my-2" />
                        <div
                          // style={{ height: "100%", overflow: "auto" }}
                          className="p-3">
                          {/* History content will be loaded here */}
                          <ContactActivity
                            module_id={leadData?.id}
                            module_name={"lead"}
                            headers={headers}
                            extras={extras}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <RightLeadDetailsPanel
                leadId={leadId}
                onClose={onClose}
                onEdit={onEdit}
                onDelete={onDelete}
                leadData={leadData}
                canEdit_canDownload={canEdit_canDownload}
                leadDocGrant={leadDocGrant}
                leadGrant={leadGrant}
                followupGrant={followupGrant}
                leadMeetingGrant={leadMeetingGrant}
                leadNoteGrant={leadNoteGrant}
                setCallLogOpen={setCallLogOpen}
                isActionDropReqd={true}
              />
            </Row>
          </div>
        </Offcanvas.Body >
      </Offcanvas >

      {/* Email Modal */}
      < EmailModal
        show={showEmailModal}
        onClose={handleCloseEmailModal}
        leadId={leadId}
        pipelineId={leadData?.pipeline_id}
        customerId={customerId}
        loginId={loginId}
        headers={headers}
        extras={extras}
        leadData={leadData} // Pass lead data for pre-populating emails
      />
      {/* WhatsApp Modal */}
      {
        showWhatsappModal && (
          <WhatsappModal
            whatsappModalOpen={showWhatsappModal}
            setWhatsAppModalOpen={setShowWhatsappModal}
            id={leadId}
            module_name={"leads"}
          />
        )
      }

      {/* WhatsApp Modal */}
      {showWhatsappModal && (
        <WhatsappModal
          whatsappModalOpen={showWhatsappModal}
          setWhatsAppModalOpen={setShowWhatsappModal}
          id={leadId}
          module_name={"leads"}
        />
      )}

      {/* {modal for call log} */}
      {callLogOpen && (
        <DyanmicCallLog
          show={callLogOpen}
          onCloseModal={() => setCallLogOpen(false)}
          module_id={leadId}
          module_name={'lead'}
        />
      )}
      {showtwilioModal && (
        <TwilioIntegrationForm
          isOpen={showtwilioModal}
          onClose={() => setShowTwilioModal(false)}
        />
      )}
      {/* global */}
      {globalDiller && (
        <GlobalCallModal
          isOpen={globalDiller}
          customerId={customerId}
          loginUserId={customer?.customer_details?.id}
          phoneNumber={getMobileNumberByType(leadData?.user_phone, "Mobile")}
          onClose={handleGlobalCallChange}
          module_name={"lead"}
          module_id={leadId}
        />
      )}
      {/* Confirmation Dialog Modal */}

      {
        showConfirmDialog && (
          <Modal
            show={true}
            onHide={closeConfirmDialog}
            centered
            backdrop="static"
            style={{ zIndex: 1055 }}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {confirmAction?.status === "won"
                  ? "Confirm Win"
                  : `Confirm ${confirmAction?.status}`}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="d-flex flex-column gap-3">
                <p className="mb-0">
                  {confirmAction?.status === "won" ? (
                    "Converting to Deal and cannot be undone. Are you sure?"
                  ) : (
                    <>
                      Are you sure you want to mark this lead as{" "}
                      <span style={{ fontSize: "1rem", fontWeight: "500" }}>
                        {confirmAction?.status?.charAt(0).toUpperCase() +
                          confirmAction?.status?.slice(1)}
                      </span>
                      ? This action cannot be undone.
                    </>
                  )}
                </p>

                {confirmAction?.status === "won" && (
                  <Form className="form-container">
                    <Row className="g-3">
                      {/* Document Title */}
                      <Col md={12}>
                        <Form.Group className="mb-3 position-relative focus-z-index d-flex flex-column">
                          <Form.Label className="mb-1">Deal Title</Form.Label>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              onChange={(e) => setDocumentTitle(e.target.value)}
                              placeholder="Enter deal title"
                            />
                          </InputGroup>
                        </Form.Group>
                      </Col>

                      {/* Currency */}
                      <Col md={12}>
                        <Form.Group
                          className="mb-3 position-relative focus-z-index d-flex flex-column"
                        >
                          <Form.Label
                            className="w-auto"
                            style={{ marginBottom: "2px", marginTop: "2px" }}
                          >
                            Currency <span className="text-danger">*</span>
                          </Form.Label>

                          <Select
                            options={currencyOpt}
                            value={
                              selectedCurrencyId
                                ? currencyOpt.find((o) => o.value === selectedCurrencyId)
                                : null
                            }
                            onChange={(option) =>
                              setSelectedCurrencyId(option ? option.value : null)
                            }
                            isSearchable
                            isClearable
                            classNamePrefix="react-select"
                            placeholder="Select currency..."
                            menuPortalTarget={document.body}
                            styles={{
                              ...customStyles,
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              ...customStyles,
                            }}
                          />
                        </Form.Group>
                      </Col>

                      {/* Pipeline */}
                      <Col md={6}>
                        <Form.Group className="mb-3 position-relative focus-z-index d-flex flex-column">
                          <Form.Label className="mb-1">Deals Pipeline</Form.Label>
                          <Select
                            options={pipelineOptions}
                            value={pipelineOptions.find((o) => o.value === selectedPipelineId)}
                            onChange={(option) =>
                              setSelectedPipelineId(option ? option.value : "")
                            }
                            classNamePrefix="react-select"
                            isSearchable
                            placeholder="Select pipeline..."
                            menuPortalTarget={document.body}
                            styles={{
                              ...customStyles,
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </Form.Group>
                      </Col>

                      {/* Stage */}
                      <Col md={6}>
                        <Form.Group className="mb-3 position-relative focus-z-index d-flex flex-column">
                          <Form.Label className="mb-1 ">Deals Stage</Form.Label>
                          <Select
                            options={pipelineStage}
                            value={
                              pipelineStage.find((o) => o.value === selectedStageId) || null
                            }
                            onChange={(option) =>
                              setSelectedStageId(option ? option.value : "")
                            }
                            isSearchable
                            classNamePrefix="react-select"
                            placeholder="Select stage..."
                            menuPortalTarget={document.body}
                            styles={{
                              ...customStyles,
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </Form.Group>
                      </Col>

                    </Row>
                  </Form>
                )}

                {confirmAction?.needsReason && (
                  <div className="d-flex flex-column gap-2">
                    <label className="form-label">Reason *</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder={`Please provide a reason for marking as ${confirmAction?.status}`}
                      required
                      style={{ resize: "vertical" }}
                      autoFocus
                    />
                  </div>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-end gap-2">
              <button className="btn btn-default-outline" onClick={closeConfirmDialog}>
                Cancel
              </button>
              <button
                className="btn btn-default"
                onClick={executeStatusChange}
                disabled={confirmAction?.needsReason && !reason.trim()}
              >
                Confirm
              </button>
            </Modal.Footer>
          </Modal>
        )
      }
    </div >
  )
}

const styles = {
  bottomP: {
    fontSize: 11,
  },
  bottomH4: {
    marginBottom: 2,
  },
  buttons: {
    color: "#fff",
    fontSize: "13px",
    height: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  filterbuttons: {
    fontSize: "13px",
    height: "33px",
    width: "33px",
    maxHeight: 33,
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ulStyles: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
    justifyContent: "space-between",
    width: "100%",
  },
  listButtonsStyles: {
    fontSize: "18px",
    height: "34px",
    width: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  listWhatsButtonsStyles: {
    fontSize: "13px",
    height: "29px",
    gap: 5,
    width: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  navButtonsStyles: {
    fontSize: "15px",
    height: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  iconStyles: {
    fontSize: 12,
    color: "#fff",
  },
  emptyDivs: {
    borderRight: "1px solid #E0E4F8",
    height: "35px",
    margin: "0px 2px",
  },
  DropdownItemsStyle: {
    fontSize: ".93re",
    letterSpacing: ".0386rem",
    fontWeight: 400,
    color: "#2e384d",
  },
  navLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  inActiveNavLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
    pointerEvents: "none",
  },
  tabContainer: {
    border: "1px solid #E0E4F8",
    borderRadius: "4px",
  },
  stickyHeader: {
    paddingBottom: "12px",
    paddingTop: "12px",
    position: "sticky",
    background: "#fff",
    top: "0px",
    background: "#fff",
    borderRadius: 0,
    borderBottom: "1px solid rgb(224, 228, 248)",
    borderTop: "1px solid rgb(224, 228, 248)",
    borderLeft: "1px solid rgb(224, 228, 248)",
    borderRight: "1px solid rgb(224, 228, 248)",
    zIndex: 1,
  },
  labels: {
    fontSize: "12px",
    color: "#B0BAC9",
    fontWeight: 400,
  },
  iconsStyles: {
    color: "#2656a8",
    border: "1px solid #e6e6e6",
    background: "#e9f1ff",
    padding: "8px",
    borderRadius: "50%",
    marginRight: "10px",
    width: "11px",
    height: "11px",
    fontSize: "13px",
  },
  values: {
    color: "#2e384d",
    fontWeight: 400,
    fontSize: ".8333rem",
    letterSpacing: "0.25px"
  },
  sectionTitle: {
    fontSize: "17px",
    fontWeight: 300,
    marginLeft: "14px",
    marginBottom: "19px",
  },
}

// const defaultd = { fullName: fullName, email: email, id: leadId }
